import {
  resolveUsgaSettings as sharedResolveUsgaSettings,
  USGA_SETTINGS_PATH as SharedUsgaSettingsPath,
} from "shared/dist/types/UsgaSettings";

export type { UsgaSettings } from "shared/dist/types/UsgaSettings";

export const USGA_SETTINGS_PATH = SharedUsgaSettingsPath;
export const resolveUsgaSettings = sharedResolveUsgaSettings;
